<template>
  <a-select
    :value="value"
    :style="{ width: '100%' }"
    placeholder="Выберите теги"
    show-search
    :mode="multiple ? 'multiple' : undefined"
    :loading="crmTagsSelect.isLoading"
    :filter-option="fuzzyMatchOption"
    :options="sortedOptions"
    @search="crmTagsSelect.search"
    @focus="crmTagsSelect.resetOptions"
    @change="updateValue" />
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useCrmTagsSelect } from '@/composables/CrmTagsSelect';
import { fuzzyMatchOption } from '@/helpers/fuzzyMatchOption';
import config from '@/config'; // eslint-disable-line import/extensions

const props = defineProps({
  value: {
    type: [Number, Array],
    default: null,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:value']);

const validateValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }
  if (props.multiple) {
    return Array.isArray(value) && value.every((v) => !isNaN(v));
  }
  return true;
};

const updateValue = (newValue) => {
  if (validateValue(newValue)) {
    emit('update:value', newValue);
  }
};

const crmTagsSelect = reactive(useCrmTagsSelect());

const sortedOptions = computed(() => {
  if (!crmTagsSelect.options?.length) return [];

  const { bottomTags } = config;

  return [...crmTagsSelect.options].sort((a, b) => {
    const aLabel = a.label || String(a.value);
    const bLabel = b.label || String(b.value);

    const aIsBottom = bottomTags && new RegExp(bottomTags).test(aLabel);
    const bIsBottom = bottomTags && new RegExp(bottomTags).test(bLabel);

    if (aIsBottom && !bIsBottom) {
      return 1;
    } if (!aIsBottom && bIsBottom) {
      return -1;
    }

    return 0;
  });
});
</script>
